
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/block-wifi",
      function () {
        return require("private-next-pages/android/local/block-wifi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/block-wifi"])
      });
    }
  